// extracted by mini-css-extract-plugin
module.exports = {"header":"aboutme-module--header--3QSNZ","aboutLine":"aboutme-module--aboutLine--2eX0u"};